import React from "react";
import { Route } from "react-router-dom";
import HTTP401 from "./HTTP401";
import HTTP403 from "./HTTP403";
import HTTP404 from "./HTTP404";
var RoutePath;
(function(RoutePath) {
    RoutePath["Unauthorized"] = "/unauthorized";
    RoutePath["Forbidden"] = "/forbidden";
    RoutePath["Default"] = "*";
})(RoutePath || (RoutePath = {}));
var ErrorRoutes = [
    /*#__PURE__*/ React.createElement(Route, {
        key: RoutePath.Unauthorized,
        path: RoutePath.Unauthorized,
        exact: true
    }, /*#__PURE__*/ React.createElement(HTTP401, null)),
    /*#__PURE__*/ React.createElement(Route, {
        key: RoutePath.Forbidden,
        path: RoutePath.Forbidden,
        exact: true
    }, /*#__PURE__*/ React.createElement(HTTP403, null)),
    /*#__PURE__*/ React.createElement(Route, {
        key: RoutePath.Default,
        path: RoutePath.Default
    }, /*#__PURE__*/ React.createElement(HTTP404, null))
];
export default ErrorRoutes;
